import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListMatchListGroupPayload } from '@app-store/slices/matchListGroups/list'

interface TaskAction extends Action {
    payload: IListMatchListGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchListGroups.list

function* listMatchListGroupSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/match-list-groups`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listMatchListGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listMatchListGroupSagaTask)
}

export default listMatchListGroupSaga
